import { persons } from '@/mocks/persons';
import { cases } from '@/mocks/cases';
import type { CaseItem, Person, ToneKey } from '@/types/content';

export function getPerson(id: string): Person | undefined {
  return (persons as readonly Person[]).find((p) => p.id === id);
}

export function getPersonName(id: string): string {
  return getPerson(id)?.name ?? '未知人物';
}

export function getCase(id: string): CaseItem | undefined {
  return (cases as readonly CaseItem[]).find((c) => c.id === id);
}

export const toneLineClass: Record<ToneKey, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-400',
  foreground: 'bg-foreground-300',
};

export const toneChipClass: Record<ToneKey, string> = {
  primary: 'bg-primary-100 text-primary-700 border-primary-200',
  accent: 'bg-accent-100 text-accent-800 border-accent-200',
  secondary: 'bg-secondary-100 text-secondary-900 border-secondary-200',
  foreground: 'bg-background-200 text-foreground-700 border-background-300',
};

export const stanceClass: Record<string, string> = {
  否认: 'bg-primary-100 text-primary-700',
  承认: 'bg-accent-100 text-accent-800',
  律师函: 'bg-secondary-200 text-secondary-900',
  澄清: 'bg-background-200 text-foreground-800',
  未回应: 'bg-foreground-100 text-foreground-600',
};

export function heatTier(heat: number): { label: string; className: string } {
  if (heat >= 90) return { label: '爆', className: 'bg-primary-500 text-background-50' };
  if (heat >= 80) return { label: '热', className: 'bg-secondary-500 text-primary-950' };
  if (heat >= 70) return { label: '温', className: 'bg-accent-500 text-primary-950' };
  return { label: '冷', className: 'bg-background-300 text-foreground-700' };
}